import React from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Dashboard from "./Page/Dashboard/Dashboard";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import Login from "./Page/Authentication/Login";
import Forgotpassword from "./Page/Authentication/Forgotpassword";
import ResetPassword from "./Page/Authentication/ResetPassword";
import Layout from "./layout";
import RequireAuth from "./RequireAuth";
import Profile from "./Page/Profile/Profile";
import WebSetting from "./Page/Settings/WebSetting";
import Category from "./Page/Category/Category";
import AddCategory from "./Page/Category/AddCategory";
import EmailConfiguration from "./Page/Settings/EmailConfiguration";
import EmailTemplate from "./Page/Settings/EmailTemplate";
import AddEmailTemplate from "./Page/Settings/AddEmailTemplate";
import AddQuality from "./Page/Quality/AddQuality";
import Quality from "./Page/Quality/Quality";
import PackSize from "./Page/PackSize/PackSize";
import AddPackSize from "./Page/PackSize/AddPackSize";
import Traceability from "./Page/Traceability/Traceability";
import AddTraceability from "./Page/Traceability/AddTraceability";
import PackBag from "./Page/PackBag/PackBag";
import AddPackBag from "./Page/PackBag/AddPackBag";
import Country from "./Page/Country/Country";
import AddCountry from "./Page/Country/AddCountry";
import PriceType from "./Page/PriceType/PriceType";
import AddPriceType from "./Page/PriceType/AddPriceType";
import PriceList from "./Page/PriceList/PriceList";
import AddPriceList from "./Page/PriceList/AddPriceList";
import Grind from "./Page/Grind/Grind";
import AddGrind from "./Page/Grind/AddGrind";
import Products from "./Page/Products/Products";
import AddProducts from "./Page/Products/AddProducts";
import ImportExportProduct from "./Page/ImportExportProduct/ImportExportProduct";
import Menu from "./Page/Menu/Menu";
import AddMenu from "./Page/Menu/AddMenu";
// import SubMenu from "./Page/Menu/SubMenu";
// import AddSubMenu from "./Page/Menu/AddSubMenu";
import Customers from "./Page/Customers/Customers";
import CustomerDetails from "./Page/Customers/CustomerDetails";
import Orders from "./Page/Orders/Orders";
import OrderDetail from "./Page/Orders/OrderDetail";
import OrderStatus from "./Page/OrderStatus/OrderStatus";
import AddOrderStatus from "./Page/OrderStatus/AddOrderStatus";
import PaymentStatus from "./Page/PaymentStatus/PaymentStatus";
import AddPaymentStatus from "./Page/PaymentStatus/AddPaymentStatus";
import BulkPriceList from "./Page/ImportExportProduct/BulkPriceList";
import Page from "./Page/pagePermission/page/page";
import AddUser from "./Page/pagePermission/Users/AddUser";
import Users from "./Page/pagePermission/Users/Users";
import Permission from "./Page/pagePermission/Permission/Permission";
import PermissionProvider from "./context/PermissionProvider";
import ProtectedRoute from "./helper/ProtectedRoute";

function App() {
  let accessToken = localStorage.getItem("AlEzziAdminToken");
  return (
     <PermissionProvider>
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            accessToken ? <Navigate to="/dashboard" replace /> : <Login />
          }
        />
        <Route
          path="/forgot-password"
          element={
            accessToken ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <Forgotpassword />
            )
          }
        />
        <Route
          path="/reset-password"
          element={
            accessToken ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <ResetPassword />
            )
          }
        />

        <Route
          path="*"
          element={
            <RequireAuth>
              <Layout>
                <Routes>
                  <Route path="/products"  element={<ProtectedRoute pageKey="Products" > <Products /> </ProtectedRoute>} />
                  <Route path="/add-product" element={<ProtectedRoute pageKey="Products" > <AddProducts /> </ProtectedRoute>} />
                  <Route
                    path="/import-export-product"
                    element={ <ProtectedRoute pageKey="Import Export Products" >  <ImportExportProduct /> </ProtectedRoute> }
                  />
                  <Route path="/bulk-price-list" element={<ProtectedRoute pageKey="Bulk Price List" > <BulkPriceList /> </ProtectedRoute>} />
                  <Route path="/grinds" element={ <ProtectedRoute pageKey="Grinds" > <Grind /> </ProtectedRoute> } />
                  <Route path="/add-grind" element={ <ProtectedRoute pageKey="Grinds" > <AddGrind /> </ProtectedRoute> } />
                  <Route path="/price-list" element={ <ProtectedRoute pageKey="Price List" > <PriceList /> </ProtectedRoute> } />
                  <Route path="/add-price-list" element={ <ProtectedRoute pageKey="Price List" > <AddPriceList /> </ProtectedRoute> } />
                  <Route path="/quality" element={ <ProtectedRoute pageKey="Quality" > <Quality /> </ProtectedRoute> } />
                  <Route path="/add-quality" element={ <ProtectedRoute pageKey="Quality" > <AddQuality /> </ProtectedRoute> } />
                  <Route path="/pack-size" element={ <ProtectedRoute pageKey="Pack Size" > <PackSize /> </ProtectedRoute> } />
                  <Route path="/add-pack-size" element={ <ProtectedRoute pageKey="Pack Size" > <AddPackSize /> </ProtectedRoute> } />
                  <Route path="/traceability" element={ <ProtectedRoute pageKey="Source" > <Traceability /> </ProtectedRoute> } />
                  <Route path="/add-traceability" element={ <ProtectedRoute pageKey="Source" > <AddTraceability /> </ProtectedRoute> } />
                  <Route path="/pack-bag" element={ <ProtectedRoute pageKey="Pack Bag" > <PackBag /> </ProtectedRoute> } />
                  <Route path="/add-pack-bag" element={ <ProtectedRoute pageKey="Pack Bag" > <AddPackBag /> </ProtectedRoute> } />
                  <Route path="/country" element={ <ProtectedRoute pageKey="Country" > <Country /> </ProtectedRoute> } />
                  <Route path="/add-country" element={ <ProtectedRoute pageKey="Country" > <AddCountry /> </ProtectedRoute> } />
                  <Route path="/price-type" element={ <ProtectedRoute pageKey="Price Type" > <PriceType /> </ProtectedRoute> } />
                  <Route path="/add-price-type" element={ <ProtectedRoute pageKey="Price Type" > <AddPriceType /> </ProtectedRoute> } />
                  <Route path="/dashboard" element={  <Dashboard /> }/>
                  <Route path="/profile" element={ <ProtectedRoute pageKey="Profile" > <Profile /> </ProtectedRoute> } />
                  <Route path="/website-setting" element={ <ProtectedRoute pageKey="Website Setting" > <WebSetting /> </ProtectedRoute> } />
                  <Route path="/categories" element={ <ProtectedRoute pageKey="Categories" > <Category /> </ProtectedRoute> } />
                  <Route path="/add-category" element={ <ProtectedRoute pageKey="Categories" > <AddCategory /> </ProtectedRoute> } /> 
                  <Route path="/email-configuration" element={ <ProtectedRoute pageKey="Email Configuration" > <EmailConfiguration /> </ProtectedRoute> } />
                  <Route path="/email-template" element={ <ProtectedRoute pageKey="Email Template" > <EmailTemplate /> </ProtectedRoute> } />
                  <Route path="/add-email-template" element={ <ProtectedRoute pageKey="Email Template" > <AddEmailTemplate /> </ProtectedRoute> } />
                  <Route path="/menu" element={ <ProtectedRoute pageKey="Menu" > <Menu /> </ProtectedRoute> } />
                  <Route path="/add-menu" element={ <ProtectedRoute pageKey="Menu" > <AddMenu /> </ProtectedRoute> } />
                  <Route path="/customers" element={ <ProtectedRoute pageKey="Customers" > <Customers /> </ProtectedRoute> } />
                  <Route path="/customer-details" element={ <ProtectedRoute pageKey="Customers" > <CustomerDetails /> </ProtectedRoute> } />
                  <Route path="/orders" element={ <ProtectedRoute pageKey="Orders" > <Orders /> </ProtectedRoute> } />
                  <Route path="/order-details/:id" element={ <ProtectedRoute pageKey="Order Details" > <OrderDetail /> </ProtectedRoute> } />
                  <Route path="/order-status" element={ <ProtectedRoute pageKey="Order Status" > <OrderStatus /> </ProtectedRoute> } />
                  <Route path="/add-order-status" element={ <ProtectedRoute pageKey="Order Status" > <AddOrderStatus /> </ProtectedRoute> } />
                  <Route path="/payment-status" element={ <ProtectedRoute pageKey="Payment Status" > <PaymentStatus /> </ProtectedRoute> } />
                  <Route path="/add-payment-status" element={ <ProtectedRoute pageKey="Payment Status" > <AddPaymentStatus /> </ProtectedRoute> } />

                  <Route path="/email-configuration" element={ <ProtectedRoute pageKey="Email Configuration" > <EmailConfiguration /> </ProtectedRoute> } />
                  <Route path="/email-template" element={ <ProtectedRoute pageKey="Email Template" > <EmailTemplate /> </ProtectedRoute> } />
                  <Route path="/page" element={ <ProtectedRoute pageKey="Page" > <Page /> </ProtectedRoute> } />
                  <Route path="/users" element={ <ProtectedRoute pageKey="Page" > <Users /> </ProtectedRoute> } />
                  <Route path="/add-users" element={ <ProtectedRoute pageKey="Page" > <AddUser /> </ProtectedRoute> } />
                  <Route path="/permission/:userId" element={ <ProtectedRoute pageKey="Page" > <Permission /> </ProtectedRoute> } />
                </Routes>
              </Layout>
            </RequireAuth>
          }
        />
      </Routes>
      <ToastContainer autoClose={1000} />
    </Router>
    </PermissionProvider>
  );
}

export default App;
